module.exports = {
      id: "home-banner-adguard-display-usage",
      viewBox: "0 0 648 445",
      url: __webpack_public_path__ + "images/js_src_vue/page_adguard_landing/sprite.dab809d9.svg#home-banner-adguard-display-usage",
      toString: function () {
        return this.url;
      }
    }